import {
  useCurriculum,
  useSubjectPlan,
  useUnitPlan,
} from "@twinkltech/curriculum-architect-domain-hooks";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { getUnitFromCell } from "@/utils/getUnitFromCell/getUnitFromCell";

import { SchemeOverview } from "./SchemeOverview";
import { SCHEME_OVERVIEW_NS } from "./SchemeOverview.i18n";

export const SchemeOverviewContainer = () => {
  const { t } = useTranslation(SCHEME_OVERVIEW_NS);
  const {
    cell_id: cellId = "generic",
    curriculum_id: curriculumId = "",
    scheme_id: schemeId = "",
    subject_id: subjectId = "",
  } = useParams();

  const params = {
    subjectId,
    schemeId,
    curriculumId,
    cellId,
  };

  if (!curriculumId || !schemeId || !subjectId) {
    throw new Error(
      t("errors.unit-plan-params-required", {
        params: JSON.stringify(params),
      })
    );
  }

  const {
    data: curriculum,
    error: curriculumError,
    isLoading: isLoadingCurriculum,
  } = useCurriculum({
    id: curriculumId,
  });

  const {
    data: unitPlan,
    error: unitPlanError,
    isLoading,
  } = useUnitPlan({ curriculumId, unitId: schemeId, subjectId });

  const {
    data: subjectPlan,
    error: subjectPlanError,
    isLoading: isLoadingSubjectPlan,
  } = useSubjectPlan({
    curriculumId,
    subjectId,
  });

  const unitInfo = getUnitFromCell(
    cellId,
    subjectPlan,
    unitPlan?.monolithUnitId ?? ""
  );

  return (
    <SchemeOverview
      curriculum={curriculum}
      description={unitPlan?.unitDescription}
      error={curriculumError || unitPlanError || subjectPlanError}
      isLoading={isLoading || isLoadingCurriculum || isLoadingSubjectPlan}
      keyArt={unitPlan?.keyArt}
      resources={unitPlan?.resources ?? []}
      subject={unitPlan?.subject}
      subjectId={subjectId ?? ""}
      title={unitPlan?.unitTitle}
      type={unitPlan?.type ?? null}
      unitId={schemeId ?? ""}
      unitInfo={unitInfo}
      unitPack={
        unitPlan
          ? {
              id: unitPlan.monolithUnitId,
              type: unitPlan.type,
              title: unitPlan.unitTitle,
              canonicalUrl: unitPlan.canonicalUrl,
            }
          : null
      }
    />
  );
};
